import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nProvider"] */ "/calcom/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/calcom/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/calcom/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/calcom/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/calcom/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/CalSans-SemiBold.woff2\",\"variable\":\"--font-cal\",\"preload\":true,\"display\":\"block\",\"weight\":\"600\"}],\"variableName\":\"calFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/calcom/node_modules/react-inlinesvg/dist/index.mjs");
